require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-spaghetti-bridge.json") })
        }
      }, "path---projecten-spaghetti-bridge");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-spaghetti-bridge!./.cache/json/projecten-spaghetti-bridge.json
// module id = 443
// module chunks = 231608221292675